import {type ImageStyle, type StyleProp} from 'react-native'
import {Image} from 'expo-image'

export function Logotype({
  width = 128,
  style,
}: {
  fill?: string
  width?: number | string
  style?: StyleProp<ImageStyle>
}) {
  const size = Number.parseInt(String(width), 10)

  return (
    <Image
      source={require('../../../assets/echoroom/wordmark.png')}
      contentFit="cover"
      contentPosition="center"
      accessibilityLabel="EchoRoom"
      style={[{width: size, height: size / 7.7}, style]}
    />
  )
}
